// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ni-5";
export var filledCircle = "_ni-4";
export var historyEntry = "_ni-3";
export var messageSideLeft = "_ni-1";
export var messageSideRight = "_ni-2";
export var orderTrackingCarouselWrapper = "_ni-6";
export var orderTrackingInfoContainer = "_ni-0";